import classNames from 'classnames';
import IwLink from '../../iwRouter/IwLink';
import styles from './NavLink.module.css';

type Props = {
    to: string;
    disableRedirect?: boolean;
    className?: string;
    activeClassName?: string;
    'data-testid'?: string;
    children: React.ReactNode;
};

export const NavLink = ({
    to,
    disableRedirect,
    className,
    activeClassName,
    ['data-testid']: dataTestId,
    children
}: Props) => (
    <IwLink
        data-testid={dataTestId}
        to={to}
        activeClassName={classNames([
            styles.NavLinkActive,
            styles.link,
            activeClassName
        ])}
        className={classNames([styles.NavLink, styles.link, className])}
        disableRedirect={disableRedirect}
    >
        {children}
    </IwLink>
);
